import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { copy } from "copy-anything";
import {
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import ProductLoop from "components/Accessories/ProductLoopCategory.js";
import PriceFilter from "components/Filter/PriceFilter.js";

function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}

class ProductCat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPerPage: 10,
      showTotal: 10,
      products: [],
      productsOriginal: [],
      categories: [],
      tags: [],
      sortData: "",
      filterModal: false,
      priceFilter: {
        selected: [0, 10000],
        min: 0,
        max: 10000,
      },
      categoryName: "",
      selectedCategoryIndex: null
    };
  }

  componentDidMount() {
    const { id } = this.props.params;
    window.scrollTo(0, 0);
    this.loadCategories(id);
    this.loadProducts(id);
    this.loadTags(id);
  }

  loadTags = (id) => {
    fetch("../API/accessoriesTags.json")
      .then((res) => res.json())
      .then((data) => {
        const tags = data
          .filter((item) => item.category.includes(id))
          .map((tag) => ({ ...tag, checked: false }));
        this.setState({ tags });
      })
      .catch(console.error);
  };

  loadProducts = (id) => {
    fetch("../API/accessories.json")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter((item) =>
          item.category.includes(id)
        );
        this.setState({
          products: filtered,
          productsOriginal: copy(filtered)
        });
      })
      .catch(console.error);
  };

  loadCategories = (id) => {
    fetch("../API/accessoriesCategory.json")
      .then((res) => res.json())
      .then((data) => {
        let categoryName = "";
        let selectedCategoryIndex = null;
        const categories = data.map((cat, index) => {
          if (cat.id === id) {
            categoryName = cat.name;
            selectedCategoryIndex = index;
          }
          return { ...cat, checked: false };
        });
        this.setState({
          categories,
          categoryName,
          selectedCategoryIndex
        });
      })
      .catch(console.error);
  };

  toggleFilterModal = () => {
    this.setState((prev) => ({ filterModal: !prev.filterModal }));
  };

  changeSortData = (e) => {
    this.setState({ sortData: e.target.value }, () => {
      this.applyFiltersAndSort();
    });
  };

  changeTag = (tagIndex) => {
    this.setState((prev) => {
      const tags = [...prev.tags];
      tags[tagIndex].checked = !tags[tagIndex].checked;
      return { tags };
    }, this.applyFiltersAndSort);
  };

  sortProducts = (products, sortData) => {
    if (sortData === "lh") {
      return [...products].sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
    }
    if (sortData === "hl") {
      return [...products].sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
    }
    return products;
  };
  applyFilterPrice = (data) => {
    this.setState({ priceFilter: data });
  };

  applyFilter = (data) => {
    this.setState({ categories: data });
  };

  getUniqueItems = (data) => {
    const keys = ["id", "name"];
    return data.filter(
      (item, index, self) =>
        self.findIndex((v) => keys.every((k) => v[k] === item[k])) === index
    );
  };

applyFiltersAndSort = () => {
  const { priceFilter, categories, tags, productsOriginal, sortData } = this.state;
  const [minPrice, maxPrice] = priceFilter.selected;

  // Step 1: Filter by price
  let products = copy(productsOriginal).filter(
    (p) => parseFloat(p.price) >= minPrice && parseFloat(p.price) <= maxPrice
  );

  // Step 2: Filter by selected categories
  const selectedCategories = categories.filter((c) => c.checked);
  if (selectedCategories.length > 0) {
    products = products.filter((p) =>
      selectedCategories.some((cat) => p.category.includes(cat.id))
    );
  }

  // Step 3: Filter by selected tags (strict)
  const selectedTags = tags.filter((t) => t.checked);
  if (selectedTags.length > 0) {
    const selectedTagIds = selectedTags.map((t) => t.id);
    products = products.filter(
      (p) => p.tags && p.tags.some((tagId) => selectedTagIds.includes(tagId))
    );
  }

  // Step 4: Remove duplicates
  const uniqueProducts = this.getUniqueItems(products);

  // Step 5: Sort
  const sortedProducts = this.sortProducts(uniqueProducts, sortData);

  this.setState({ products: sortedProducts });
};



  resetFilterData = () => {
    this.setState(
      {
        priceFilter: { selected: [0, 10000], min: 0, max: 10000 },
        categories: this.state.categories.map((cat) => ({
          ...cat,
          checked: false
        })),
      },
      this.applyFiltersAndSort
    );
    this.toggleFilterModal();
  };

  loadMore = () => {
    this.setState((prev) => ({
      showTotal: prev.showTotal + prev.showPerPage
    }));
  };

  render() {
    const { products, categories, categoryName, selectedCategoryIndex, tags, sortData, filterModal, showTotal } = this.state;

    const ifCategories = categories.length > 0;
    const ifLoadMore = products.length > showTotal;

    return (
      <>
        <Helmet>
          {ifCategories && (
            <>
              <title>{categories[selectedCategoryIndex]?.title}</title>
              <meta name="description" content={categories[selectedCategoryIndex]?.desc} />
              <meta property="og:title" content={categories[selectedCategoryIndex]?.title} />
              <meta property="og:description" content={categories[selectedCategoryIndex]?.desc} />
            </>
          )}
        </Helmet>
        <DemoNavbar />
        <main>
          <section
            style={{
              backgroundImage: "url(images/inner-banner-bg.webp)",
              backgroundPosition: "center",
              backgroundSize: "cover"
            }}
            className="section pageTitleBG"
          >
            <div className="row m-0">
              <div className="col-12">
                <h1 className="h1 text-center text-uppercase mb-0" style={{ fontWeight: "500" }}>
                  {categoryName}
                </h1>
              </div>
            </div>
          </section>

          <section className="section">
            <Container fluid>
              <div className="row align-items-center mb-3">
                <div className="col-12 col-lg-auto">
                  <div className="form-floating">
                    <select value={sortData} name="sortData" onChange={this.changeSortData} className="form-select">
                      <option value="">Default</option>
                      <option value="lh">Price : low to high</option>
                      <option value="hl">Price : high to low</option>
                    </select>
                    <label>Sorting</label>
                  </div>
                </div>

                <div style={{ fontSize: "24px" }} className="col py-1">
                  {tags.map((item, index) => (
                    <span
                      key={index}
                      onClick={() => this.changeTag(index)}
                      className={item.checked?"badge bg-danger me-1 cursor-pointer":"badge bg-dark me-1 cursor-pointer"}
                    >
                      {item.name}{" "}
                    </span>
                  ))}
                </div>

                <div className="col-12 col-lg-auto">
                  <button onClick={this.toggleFilterModal} className="btn btn-lg btn-outline-danger">
                    <i className="fa-solid fa-filter"></i> Filter
                  </button>
                </div>
              </div>

              <div className="col-12">
                {products.length === 0 &&<div style={{minHeight:"200px"}} className="row align-items-center"><div className="h5 text-center col">Products not found..</div></div>}
                <ProductLoop showPerPage={showTotal} data={products} />
              </div>

              {ifLoadMore && (
                <div className="col-12 text-center">
                  <button className="btn btn-danger btn-lg" onClick={this.loadMore}>
                    Load More
                  </button>
                </div>
              )}
            </Container>
          </section>
        </main>

        <SimpleFooter />

        <Modal centered isOpen={filterModal} toggle={this.toggleFilterModal}>
          <ModalHeader toggle={this.toggleFilterModal}>Filter</ModalHeader>
          <ModalBody>
            <PriceFilter data={this.state.priceFilter} applyFilterPrice={this.applyFilterPrice} />
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={() => { this.applyFiltersAndSort(); this.toggleFilterModal(); }}>
              Apply Filter
            </Button>
            <Button color="dark" onClick={this.resetFilterData}>
              Reset
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default withParams(ProductCat);
